module.exports = __webpack_public_path__ + "static/media/pw.54458948.svg";